import React from "react";
import { Link } from "react-router-dom";

export default function Consultation() {
  return (
    <div className="relative max-h-fit">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="/assets/northern_installation.jpg"
          alt="Cozy Kitchen"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Overlay and Content */}
      <div className="relative z-10 bg-black bg-opacity-50 flex flex-col justify-center items-start px-6 md:px-16 py-5 md:py-14 space-y-4 text-white">
        {/* Heading */}
        <h2 className="text-lg md:text-5xl font-bold text-start">
          Free consultation with exceptional quality
        </h2>

        {/* Subheading */}
        <p className="text-start text-sm md:text-xl">
          Just one call away: +971 2586 8431
        </p>

        {/* Added Content from the image */}
        <p className="text-xs md:text-base max-w-4xl leading-relaxed text-start text-gray-200">
          Initial consultations are available at our Abudhabi-based offices, on-site*, or via online video conference calls. On-site visits and video consultations offer the advantage of allowing our designers to assess your proposed site firsthand, ensuring a deeper understanding of your project's potential and challenges.
        </p>

        {/* Button */}
        <Link
          to={"tel:+97125868431"}
          className="mt-4 px-6 py-2 md:py-3 text-sm md:text-base bg-transparent border border-white text-white hover:bg-white hover:text-black transition rounded"
        >
          Get your consultation
        </Link>
      </div>
    </div>
  );
}
